import React from "react"
import reviewerData from "../../data/reviewerData"
import ScrollableContainer from "../scroll-container"
import TestimonialCard from "./card"

function createCard(data) {
  return (
    <TestimonialCard
      reviewerName={data.reviewerName}
      reviewerAddress={data.reviewerAddress}
      reviewerImage={data.reviewerImage}
      review={data.review}
    />
  )
}

export default function Testimonial() {
  return (
    <div className="testimonial">
      <h2 style={{ padding: "2px 2px 2px 10px" }}>What our customer says</h2>
      <div className="o-scroll">{reviewerData.map(createCard)}</div>
    </div>
  )
}
